export default __webpack_public_path__ + "static/media/PerksAvailableOnApp.79bd03ae.png";